import { useSelector } from "react-redux";
import ViewData from "./ViewData";
import { getMenuEnabled } from "../../features/tableData/visualSlice";
import PlayData from "./PlayData";
import ViewMetrics from "./ViewMetrics";
import Examples from "./Examples/Examples";


export default function MainComp() {
  const menuEnabled = useSelector(getMenuEnabled);
  
  return (
    <div>
      {menuEnabled === "home" && <PlayData/>}
      {menuEnabled === "database" && <ViewData />}
      {menuEnabled === "metrics" && <ViewMetrics/>}
      {menuEnabled === "examples" && <Examples/>}
    </div>
  );
} 
